import { useEffect, useRef } from "react";

/** 콜백 디바운스 (언마운트 시 타이머 정리) */
export function useDebouncedCallback(fn, delayMs) {
    const fnRef = useRef(fn);
    fnRef.current = fn;
    const timer = useRef(null);
    useEffect(() => () => {
        if (timer.current)
            clearTimeout(timer.current);
    }, []);
    return (v) => {
        if (timer.current)
            clearTimeout(timer.current);
        timer.current = setTimeout(() => fnRef.current(v), delayMs);
    };
}
